<template>
  <div class="mine">
    <my-header title="我的" v-if="!isWechatBrowser" ></my-header>
    <div class="mine-top" :class = "{'clear-header':isWechatBrowser}">
      <div @click="install()">
        <img v-if="customerUser.avatarUrl != null && customerUser.avatarUrl != ''" class="mine-avatar" :src="customerUser.avatarUrl">
        <img v-else="" class="mine-avatar" src="../../assets/icon/icon-defualt-avatar.png">
        <div class="mine-info-bottom">
          <div class="info-name-phone">
            <div class="info-name">{{customerUser.nickname}}</div>
            <div class="info-phone">{{customerUser.phone}}</div>
          </div>
          <img src="../../assets/mine/icon-mine-edit-btn.png">
        </div>
      </div>
      <div class="mine-main-operation general-box-shadow">
        <div @click="openMineAppointment()">
          <img src="../../assets/mine/icon-mine-appointment.png">
          <div>我的预约</div>
        </div>
        <div @click="openMineProject()">
          <img src="../../assets/mine/icon-mine-project.png">
          <div>我的项目</div>
        </div>
        <div @click="toTradeOrderList">
          <img src="../../assets/mine/icon-mine-trade-order.png">
          <div>商城订单</div>
        </div>
        <div @click="toTradeOfflineList">
          <img src="../../assets/mine/icon-mine-trade-offline.png">
          <div>团购订单</div>
        </div>
      </div>
    </div>
    <div class="function-list">
      <div class="mine-cell border-bottom-style" @click="toMineActivity">
        我的活动
        <img src="../../assets/index/icon-more-btn.png">
      </div>
      <div class="mine-cell border-bottom-style" @click="toCustomerFavoriteList">
        我的收藏
        <img src="../../assets/index/icon-more-btn.png">
      </div>
      <div class="mine-cell" @click="toMinePublish">
        我的发布
        <img src="../../assets/index/icon-more-btn.png">
      </div>
      <div style="border-top:solid 0.1rem #f7f6f5;" ></div>
      <div class="mine-cell border-bottom-style" @click ="openAddressList">
        地址管理
        <img src="../../assets/index/icon-more-btn.png">
      </div>
      <div class="mine-cell" @click ="contactService">
        联系客服
        <img src="../../assets/index/icon-more-btn.png">
      </div>
    </div>
  </div>
</template>
<script>
  import {imgUrl} from '../../config'
  import {MessageBox,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import UserService from '../../service/customer/UserService'

  export default {
    name: 'Mine',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        accountToken:{},
        customerUser:{},
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.accountToken=session.getAccountToken();
      session.isLogin().then(flag => {
        if(flag){
          this.getCustomerUserInfo();
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          session.backUrl(backUrl)
          this.$router.push({name:'BindPhone'});
        }
      })
    },
    methods: {
      openMineAppointment(){
        this.$router.push({name:'MineAppointment',query:{}});
      },
      openMineProject(){
        this.$router.push({name:'MineProject',query:{}});
      },
      async getCustomerUserInfo(){
        let result=await UserService.getUserInfo();
        if(result.code == '0'){
          this.customerUser = result.data;
        }else {
          Toast('获取客户信息失败');
        }
      },
      install(){
        this.$router.push({name:'Install'});
      },
      openAddressList(){
        this.$router.push({name:'AddressList'});
      },
      toTradeOrderList(){
        this.$router.push({name:'TradeOrderList'});
      },
      toTradeOfflineList(){
        this.$router.push({name:'TradeOfflineList'});
      },
      toCustomerFavoriteList(){
        this.$router.push({name:'CustomerFavoriteList'});
      },
      toMinePublish(){
        this.$router.push({name:'MinePublish'});
      },
      toMineActivity(){
        this.$router.push({name:'MineActivity'});
      },
      async contactService(event){
        var msg="客服电话："+4000600566;
        MessageBox.confirm(msg,'联系客服',
        ).then(action => {
          window.location.href = "tel:"+4000600566;
        });
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .mine{
    font-size: 0.32rem;
    color: #7f7d7c;
    background-color: white;
    .mine-top{
      padding: 0 0.28rem;
      background: url("../../assets/mine/icon-mine-bg.png") no-repeat;
      background-size: 100%;
      .mine-avatar{
        width: 1.2rem;
        height: 1.2rem;
        margin-top: 0.5rem;
        margin-left: 0.54rem;
        border-radius: 2rem;
        border: solid 0.04rem #ffffff;
      }
      .mine-info-bottom{
        display: flex;
        justify-content: space-between;
        margin-left: 0.54rem;
        .info-name{
          padding-bottom: 0.2rem;
          font-size: 0.36rem;
          font-weight: 700;
          color: #191818;
        }
        .info-phone{
          line-height: 0.32rem;
          color: #7f7d7c;
        }
        img{
          width: 0.56rem;
          height: 0.56rem;
          margin-top: 0.18rem;
          margin-right: 0.54rem;
        }
      }
      .mine-main-operation{
        display: flex;
        justify-content: space-around;
        width: 100%;
        padding-top: 0.33rem;
        padding-bottom: 0.32rem;
        margin-top: 0.5rem;
        background-color: white;
        text-align: center;
        img{
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .function-list{
      padding-top: 0.3rem;
      .mine-cell{
        display: flex;;
        justify-content: space-between;
        width: 6.9rem;
        height: 0.93rem;
        margin: 0 auto;
        line-height: 0.93rem;
        img{
          width: 0.19rem;
          height: 0.33rem;
          margin-top: 0.3rem;
        }
      }
    }
  }
</style>
